import React from "react";
import { BaseDropDown } from "./BaseDropDown";
export const Dropdown = function (props) {
    return React.createElement(BaseDropDown, Object.assign({}, props));
};
//# sourceMappingURL=Dropdown.js.map